export default {"src":"/_next/static/media/buffer.92254132.svg","height":1324,"width":630,"blurWidth":0,"blurHeight":0};